import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { InvestorType } from "src/app/shared/enum/investor-type.enum";

@Component({
  selector: "app-cadastro-investidor",
  templateUrl: "./cadastro-investidor.component.html",
  styleUrls: ["./cadastro-investidor.component.scss"],
})
export class CadastroInvestidorComponent {

  constructor(private router: Router) {}

  hasForm: boolean = false;
  typeForm: InvestorType;

  onTipoSelecionado(typeForm: InvestorType) {
    this.typeForm = typeForm;
    this.hasForm = true;
  }

  onVoltar() {
    this.hasForm = false;
    this.typeForm = undefined;
  }

  backStep() {
    this.router.navigate(['/spg/home-dpge']);
  }
}
